import defaultState from './state'
import mutations from './mutations'
import actions from './actions'

const hail = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  mutations,
  actions,
}

export default hail



// WEBPACK FOOTER //
// ./src/store/hail/index.js